import content from "app-content";
import {
  DISPLAY_SORT_DATE_ASCENDING,
  DISPLAY_SORT_DATE_DESCENDING,
  DISPLAY_SORT_DISCOUNT,
  DISPLAY_SORT_PRICE_ASCENDING,
  DISPLAY_SORT_PRICE_DESCENDING,
  DISPLAY_SORT_BRAND_ASCENDING,
  DISPLAY_SORT_BRAND_DESCENDING,
  DISPLAY_SORT_STOCK,
  DISPLAY_SORT_RECENTLY_DISCOUNTED_STOCK
} from "../components/presentational/common/SortSelect/constants";

import {
  SORT_ORDER_DESCENDING,
  SORT_ORDER_ASCENDING,
  SORTBY_DATE,
  SORTBY_DISCOUNT,
  SORTBY_PRICE,
  SORTBY_BRAND,
  SORTBY_STOCK,
  SORTBY_RECENTLY_DISCOUNTED
} from "../state/modules/savedItems/constants";

export const sortConfig = [
  {
    text: content.saved_items_controls_sort_recently_added,
    value: DISPLAY_SORT_DATE_DESCENDING,
    sort: SORTBY_DATE,
    sortOrder: SORT_ORDER_DESCENDING
  },
  {
    text: content.saved_items_controls_sort_expiring_soonest,
    value: DISPLAY_SORT_DATE_ASCENDING,
    sort: SORTBY_DATE,
    sortOrder: SORT_ORDER_ASCENDING
  },
  {
    text: content.saved_items_sort_recently_discounted,
    value: DISPLAY_SORT_RECENTLY_DISCOUNTED_STOCK,
    sort: SORTBY_RECENTLY_DISCOUNTED,
    sortOrder: SORT_ORDER_DESCENDING
  },
  {
    text: content.saved_items_controls_sort_discount,
    value: DISPLAY_SORT_DISCOUNT,
    sort: SORTBY_DISCOUNT,
    sortOrder: SORT_ORDER_DESCENDING
  },
  {
    text: content.saved_items_controls_sort_price_high_low,
    value: DISPLAY_SORT_PRICE_DESCENDING,
    sort: SORTBY_PRICE,
    sortOrder: SORT_ORDER_DESCENDING
  },
  {
    text: content.saved_items_controls_sort_price_low_high,
    value: DISPLAY_SORT_PRICE_ASCENDING,
    sort: SORTBY_PRICE,
    sortOrder: SORT_ORDER_ASCENDING
  },
  {
    text: content.saved_items_controls_sort_brand_a_z,
    value: DISPLAY_SORT_BRAND_ASCENDING,
    sort: SORTBY_BRAND,
    sortOrder: SORT_ORDER_ASCENDING
  },
  {
    text: content.saved_items_controls_sort_brand_z_a,
    value: DISPLAY_SORT_BRAND_DESCENDING,
    sort: SORTBY_BRAND,
    sortOrder: SORT_ORDER_DESCENDING
  },
  {
    text: content.saved_items_sort_stock_level,
    value: DISPLAY_SORT_STOCK,
    sort: SORTBY_STOCK,
    sortOrder: SORT_ORDER_DESCENDING
  }
];

export const defaultSortOptions = sortConfig[0];
